// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"19c774d9","186":"fe79b712","344":"9ba6c67c","372":"328312f1","738":"1061ee49","787":"0a8029bc","841":"dda3cfbc","851":"0fde2189","856":"bfec519b"}[chunkId] + ".chunk.js";
};